import React from "react";
import {
  Grid,
  TextField,
  Box,
} from "@mui/material";

export default function SheetsStepForm({
  data,
  updateData,
  setIsValid,
  showErrors,
  urlPermissionError = false,
}) {
  const errors = {};

  if (!data.title) errors.title = "Nome é obrigatório";
  if (!data.desc) errors.desc = "Descrição é obrigatória"; // ✅ agora obrigatório
  if (!data.url) errors.url = "URL é obrigatória";

  React.useEffect(() => {
    setIsValid(!!data.title && !!data.desc && !!data.url); // ✅ incluído desc
  }, [data.title, data.desc, data.url, setIsValid]);

  const handleChange = (name) => (e) => {
    updateData({ [name]: e.target.value });
  };

  const showUrlError = (showErrors && !!errors.url) || urlPermissionError;

  return (
    <Box sx={{ width: "100%", maxWidth: 900 }}>
      <Grid container spacing={3}>
        
        {/* NOME */}
        <Grid item xs={12} md={8}>
          <TextField
            fullWidth
            label="Nome da listagem"
            placeholder="Ex: Clientes Abril 2025"
            value={data.title || ""}
            onChange={handleChange("title")}
            error={showErrors && !!errors.title}
            helperText={showErrors && errors.title}
          />
        </Grid>

        {/* DESCRIÇÃO */}
        <Grid item xs={12} md={8}>
          <TextField
            fullWidth
            label="Descrição"
            placeholder="Ex: lista de clientes que não pagaram no mês 02."
            value={data.desc || ""}
            onChange={handleChange("desc")}
            multiline
            minRows={3}
            maxRows={5}
            error={showErrors && !!errors.desc} // ✅ erro visual
            helperText={showErrors && errors.desc} // ✅ mensagem
          />
        </Grid>

        {/* LINK */}
        <Grid item xs={12} md={8}>
          <TextField
            fullWidth
            label="Link da planilha Google"
            placeholder="https://docs.google.com/spreadsheets/d/..."
            value={data.url || ""}
            onChange={handleChange("url")}
            error={showUrlError}
            helperText={showErrors && errors.url ? errors.url : null}
          />
        </Grid>

        {!showErrors && (
          <Grid item xs={12}>
            <Box
              sx={{
                fontSize: "0.85rem",
                color: urlPermissionError ? "#791414" : "#000",
                lineHeight: 1.5,
              }}
            >
              {urlPermissionError ? (
                <>
                  A planilha precisa estar compartilhada com{" "}
                  <Box
                    component="span"
                    sx={{
                      fontWeight: 600,
                      color: "#0F172A",
                      wordBreak: "break-all",
                    }}
                  >
                    planilhas-n8n@projeto-brio-n8n.iam.gserviceaccount.com
                  </Box>
                </>
              ) : (
                <>
                  Dica: compartilhe com{" "}
                  <Box
                    component="span"
                    sx={{
                      fontWeight: 600,
                      color: "#0F172A",
                      wordBreak: "break-all",
                    }}
                  >
                    planilhas-n8n@projeto-brio-n8n.iam.gserviceaccount.com
                  </Box>
                </>
              )}
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}